/* VIP-Members Discount System v5 — mit Multi-Code-Sammlung beim Checkout */

(function() {
  'use strict';

  // ====== KONFIGURATION ======
  const SHEET_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQbLYaBJt2OZntYnKAvuTn0TSHVyKoZ7-GzAbu01Anel17ngQwywJhd2K99LXnJXVQWQFEIcWeMCpe7/pub?gid=0&single=true&output=csv';
  const STORAGE_KEY = 'protect24_vip_member';
  const STORAGE_DAYS = 30;
  const CLUB_LINK = 'https://vetprotect24.de/clubmitglied';
  // ===========================

  function getStoredVip() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      const ageMs = Date.now() - data.timestamp;
      const maxAgeMs = STORAGE_DAYS * 24 * 60 * 60 * 1000;
      if (ageMs > maxAgeMs) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function storeVip(email) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        email: email,
        timestamp: Date.now()
      }));
      console.log('[VIP] Mitglieder-Status gespeichert:', email);
    } catch (e) {
      console.warn('[VIP] localStorage nicht verfügbar');
    }
  }

  function getEmailFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const email = params.get('email');
    return email ? email.trim().toLowerCase() : null;
  }

  async function loadMemberList() {
    try {
      const response = await fetch(SHEET_URL);
      if (!response.ok) throw new Error('Fetch failed: ' + response.status);
      const csvText = await response.text();
      return parseCsv(csvText);
    } catch (e) {
      console.error('[VIP] Fehler beim Laden der Mitgliederliste:', e);
      return [];
    }
  }

  function parseCsv(csv) {
    const lines = csv.trim().split(/\r?\n/);
    const members = [];
    for (let i = 1; i < lines.length; i++) {
      const cols = lines[i].split(',');
      if (cols.length < 2) continue;
      const email = cols[0].trim().toLowerCase();
      const active = cols[1].trim().toUpperCase() === 'TRUE';
      if (email && active) {
        members.push(email);
      }
    }
    return members;
  }

  function getMinQuantity() {
    const inputs = document.querySelectorAll('quantity-breaks input[type="radio"]');
    if (inputs.length < 2) return 2;
    const secondQty = parseInt(inputs[1].value, 10);
    return secondQty > 0 ? secondQty : 2;
  }

  function getDiscountPercent() {
    const container = document.querySelector('quantity-breaks');
    if (!container) return 0;
    const percent = parseInt(container.dataset.discountPercent, 10);
    return percent > 0 ? percent : 0;
  }

  function getDiscountCode() {
    const percent = getDiscountPercent();
    if (percent <= 0) return null;
    return 'VIP-' + percent + '-PROTECT24-CLUBMITGLIEDRABATT';
  }

// ====== CODE SAMMELN + DIREKT SETZEN (WebView-kompatibel) ======
  function applyDiscountCode(code) {
    if (!code) return;

    // 1) Code direkt in Session setzen via Image-Request (funktioniert in WebView!)
    const img = new Image();
    img.onload = () => console.log('[VIP] Code via Image-Request gesetzt:', code);
    img.onerror = () => console.log('[VIP] Image-Request beendet (normal):', code);
    img.src = '/discount/' + encodeURIComponent(code) + '?_t=' + Date.now();

    // 2) Code zusätzlich in Cart-Attributes sammeln
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const existing = (cart.attributes && cart.attributes.vip_codes) 
          ? cart.attributes.vip_codes.split(',').map(c => c.trim()).filter(c => c)
          : [];

        if (existing.includes(code)) {
          console.log('[VIP] Code bereits gesammelt:', code);
          return;
        }

        existing.push(code);
        const allCodes = existing.join(',');

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            attributes: { 'vip_codes': allCodes }
          })
        }).then(() => {
          console.log('[VIP] Code zu Cart-Attributen hinzugefügt:', code);
        });
      })
      .catch(e => {
        console.error('[VIP] Fehler beim Sammeln:', e);
      });
  }
  // =========================

  // ====== CHECKOUT-INTERCEPTION: Alle Codes über Redirect-Chain anwenden ======
  function setupCheckoutInterception() {
    const checkoutSelectors = [
      'button[name="checkout"]',
      'a[href*="/checkout"]',
      '.cart__checkout-button',
      '#checkout',
      '#CartDrawer-Checkout'
    ];

    function getCheckoutButtons() {
      return document.querySelectorAll(checkoutSelectors.join(','));
    }

    async function buildCheckoutUrl() {
      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        const codesAttr = cart.attributes && cart.attributes.vip_codes;
        if (!codesAttr) return '/checkout';

        const codes = codesAttr.split(',').map(c => c.trim()).filter(c => c);
        if (codes.length === 0) return '/checkout';

        // Redirect-Chain bauen: /discount/CODE1?redirect=/discount/CODE2?redirect=/checkout
        let url = '/checkout';
        for (let i = codes.length - 1; i >= 0; i--) {
          url = '/discount/' + encodeURIComponent(codes[i]) + '?redirect=' + encodeURIComponent(url);
        }

        console.log('[VIP] Checkout-URL mit allen Codes:', url);
        return url;
      } catch (e) {
        console.error('[VIP] Fehler beim Bauen der Checkout-URL:', e);
        return '/checkout';
      }
    }

    function attachInterceptor(btn) {
      if (btn.dataset.vipIntercepted === 'true') return;
      btn.dataset.vipIntercepted = 'true';

      btn.addEventListener('click', async function(e) {
        const cart = await fetch('/cart.js').then(r => r.json()).catch(() => null);
        if (!cart || !cart.attributes || !cart.attributes.vip_codes) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const url = await buildCheckoutUrl();
        window.location.href = url;
      }, true);
    }

    // Initial alle vorhandenen Buttons absichern
    getCheckoutButtons().forEach(attachInterceptor);

    // MutationObserver: auch dynamisch hinzugefügte Buttons (Cart-Drawer) abfangen
    const observer = new MutationObserver(() => {
      getCheckoutButtons().forEach(attachInterceptor);
    });
    observer.observe(document.body, { childList: true, subtree: true });

    console.log('[VIP] Checkout-Interception aktiv');
  }
  // =========================

  // ====== CLUB-PREIS ======
  function renderClubPrice(isMember, percent) {
    if (percent <= 0) return;

    const priceContainer = document.querySelector('.price__container');
    if (!priceContainer) return;

    const existing = document.querySelector('.vip-club-price');
    if (existing) existing.remove();

    const priceEl = priceContainer.querySelector('.price-item--regular, .price-item--sale');
    if (!priceEl) return;

    const priceText = priceEl.textContent.trim();
    const priceMatch = priceText.match(/[\d.,]+/);
    if (!priceMatch) return;
    const priceNumber = parseFloat(priceMatch[0].replace(/\./g, '').replace(',', '.'));
    if (isNaN(priceNumber)) return;

    const clubPrice = priceNumber * (1 - percent / 100);
    const clubPriceFormatted = '€' + clubPrice.toFixed(2).replace('.', ',');

    const wrapper = document.createElement('div');
    wrapper.className = isMember ? 'vip-club-price vip-club-price--member' : 'vip-club-price vip-club-price--guest';

    if (isMember) {
      wrapper.innerHTML = `
        <span class="vip-club-price__icon">🟢</span>
        <span class="vip-club-price__text">
          <strong>${clubPriceFormatted}</strong> / Stück als Clubmitglied (ab ${getMinQuantity()} Stück)
        </span>
      `;
    } else {
      wrapper.innerHTML = `
        <a href="${CLUB_LINK}" class="vip-club-price__link">
          <span class="vip-club-price__icon">🔒</span>
          <span class="vip-club-price__text">
            <strong>${clubPriceFormatted}</strong> / Stück für Clubmitglieder (Mehr erfahren →)
          </span>
        </a>
      `;
    }

    priceContainer.parentNode.insertBefore(wrapper, priceContainer.nextSibling);
  }

  // ====== BANNER ======
  function renderBanner(isMember, percent) {
    if (percent <= 0) return;

    const container = document.querySelector('quantity-breaks');
    if (!container) return;

    const existingBanner = document.querySelector('.vip-banner');
    if (existingBanner) existingBanner.remove();

    const banner = document.createElement('div');
    banner.className = isMember ? 'vip-banner vip-banner--member' : 'vip-banner vip-banner--guest';

    if (isMember) {
      banner.innerHTML = `
        <span class="vip-banner__icon">✅</span>
        <span class="vip-banner__text">Dein <strong>${percent}% Mitglieder-Rabatt</strong> ist aktiv!</span>
      `;
    } else {
      banner.innerHTML = `
        <a href="${CLUB_LINK}" class="vip-banner__link">
          <span class="vip-banner__icon">🔒</span>
          <span class="vip-banner__text">
            <strong>Nur für Clubmitglieder</strong><br>
            Jetzt anmelden und bis zu ${percent}% sparen →
          </span>
        </a>
      `;
    }

    container.parentNode.insertBefore(banner, container);
  }

  // ====== GESAMT-PREIS ======
  function updateTotalPrice(qty) {
    const priceContainer = document.querySelector('.price__container');
    if (!priceContainer) return;

    const existing = document.querySelector('.vip-total-price');
    if (existing) existing.remove();

    if (qty < 2) return;

    const priceEl = priceContainer.querySelector('.price-item--regular, .price-item--sale');
    if (!priceEl) return;

    const priceText = priceEl.textContent.trim();
    const priceMatch = priceText.match(/[\d.,]+/);
    if (!priceMatch) return;
    const priceNumber = parseFloat(priceMatch[0].replace(/\./g, '').replace(',', '.'));
    if (isNaN(priceNumber)) return;

    const totalPrice = priceNumber * qty;
    const totalFormatted = '€' + totalPrice.toFixed(2).replace('.', ',');

    const isMember = !!getStoredVip();
    const percent = getDiscountPercent();
    const minQty = getMinQuantity();
    const showClubTotal = isMember && percent > 0 && qty >= minQty;

    const wrapper = document.createElement('div');
    wrapper.className = 'vip-total-price';

    if (showClubTotal) {
      const clubTotal = totalPrice * (1 - percent / 100);
      const clubTotalFormatted = '€' + clubTotal.toFixed(2).replace('.', ',');

      wrapper.innerHTML = `
        <span class="vip-total-price__strike">${totalFormatted}</span>
        <strong class="vip-total-price__final">${clubTotalFormatted}</strong>
        <span class="vip-total-price__hint">(${qty} Stück gesamt)</span>
      `;
    } else {
      wrapper.innerHTML = `<strong class="vip-total-price__final">${totalFormatted}</strong> <span class="vip-total-price__hint">(${qty} Stück gesamt)</span>`;
    }

    priceContainer.parentNode.insertBefore(wrapper, priceContainer.nextSibling);
  }

  // ====== KG-HINWEIS ======
  function updateKgHint(qty) {
    document.querySelectorAll('.vip-kg-hint').forEach(el => el.remove());
    document.querySelectorAll('.unit-price.vip-hidden').forEach(el => {
      el.classList.remove('vip-hidden');
    });

    if (qty < 2) return;

    const isMember = !!getStoredVip();
    const percent = getDiscountPercent();
    const minQty = getMinQuantity();
    if (!isMember || percent <= 0 || qty < minQty) return;

    const unitPrice = document.querySelector('.price__container .unit-price')
                   || document.querySelector('.price--large .unit-price')
                   || document.querySelector('main .unit-price');
    if (!unitPrice) return;

    const clone = unitPrice.cloneNode(true);
    clone.querySelectorAll('.visually-hidden').forEach(el => el.remove());
    const fullText = clone.textContent.trim();

    const priceMatch = fullText.match(/[\d.,]+/);
    if (!priceMatch) return;
    const originalKgPrice = parseFloat(priceMatch[0].replace(/\./g, '').replace(',', '.'));
    if (isNaN(originalKgPrice) || originalKgPrice <= 0) return;

    const parts = fullText.split('/');
    const unit = parts.length > 1 ? parts[parts.length - 1].trim() : 'kg';

    const discountedKgPrice = originalKgPrice * (1 - percent / 100);
    const discountedFormatted = '€' + discountedKgPrice.toFixed(2).replace('.', ',');

    unitPrice.classList.add('vip-hidden');

    const hint = document.createElement('span');
    hint.className = 'vip-kg-hint';
    hint.innerHTML = `<strong>${discountedFormatted} / ${unit}</strong> als Clubmitglied`;

    unitPrice.parentNode.insertBefore(hint, unitPrice.nextSibling);

    console.log('[VIP] KG-Hinweis eingefügt:', originalKgPrice, '→', discountedKgPrice, unit);
  }

  // ====== VISIBILITY-HANDLER ======
  function setupClubPriceVisibility() {
    const inputs = document.querySelectorAll('quantity-breaks input[type="radio"]');
    if (!inputs.length) return;

    function updateVisibility() {
      const checked = document.querySelector('quantity-breaks input[type="radio"]:checked');
      const clubPrice = document.querySelector('.vip-club-price');
      const minQty = getMinQuantity();
      const currentQty = checked ? parseInt(checked.value, 10) : 1;

      if (clubPrice) {
        if (currentQty >= minQty) {
          clubPrice.style.display = '';
        } else {
          clubPrice.style.display = 'none';
        }
      }

      updateTotalPrice(currentQty);
      updateKgHint(currentQty);
    }

    updateVisibility();

    inputs.forEach(input => {
      input.addEventListener('change', updateVisibility);
    });
  }

  // ====== INIT ======
  async function init() {
    console.log('[VIP] Init gestartet...');

    let vipData = getStoredVip();
    const urlEmail = getEmailFromUrl();

    if (urlEmail) {
      console.log('[VIP] URL-Email gefunden:', urlEmail);
      const members = await loadMemberList();
      console.log('[VIP] Mitgliederliste geladen:', members.length, 'Einträge');

      if (members.includes(urlEmail)) {
        console.log('[VIP] ✅ Email ist auf Whitelist');
        storeVip(urlEmail);
        vipData = { email: urlEmail };
      } else {
        console.log('[VIP] ❌ Email nicht auf Whitelist');
      }
    }

    const percent = getDiscountPercent();

        if (vipData) {
      document.body.classList.add('vip-active');  // ← NEU
      const code = getDiscountCode();
      if (code) {
        console.log('[VIP] Mitglied erkannt — sammle Code:', code);
        applyDiscountCode(code);
      }
      renderBanner(true, percent);
      renderClubPrice(true, percent);
    } else {
      console.log('[VIP] Kein Mitglieder-Status erkannt');
      renderBanner(false, percent);
      renderClubPrice(false, percent);
    }

    setupClubPriceVisibility();
    setupCheckoutInterception();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();